// components/OperationDashboard/QuickStatCard.js
import React from "react";
import { Box, Typography, Avatar, Paper, Chip, alpha, useTheme } from "@mui/material";

const QuickStatCard = ({ title, value, icon, color, subtitle, trend }) => {
  const theme = useTheme();

  return (
    <Paper
      sx={{
        p: 2.5,
        borderRadius: 2,
        border: `1px solid ${alpha(color, 0.1)}`,
        backgroundColor: "white",
        transition: "all 0.2s",
        position: "relative",
        overflow: "hidden",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: 3,
          bgcolor: color,
        },
        "&:hover": {
          boxShadow: theme.shadows[4],
          transform: "translateY(-4px)",
        },
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <Box>
          <Typography
            variant="caption"
            color="text.secondary"
            fontWeight={500}
            sx={{ fontSize: "0.7rem" }}
          >
            {title}
          </Typography>
          <Typography
            variant="h4"
            fontWeight={700}
            sx={{ color: color, mt: 0.5, fontSize: "2rem" }}
          >
            {value}
          </Typography>
          {subtitle && (
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mt: 0.25 }}>
              <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
                {subtitle}
              </Typography>
              {trend && (
                <Chip
                  label={trend}
                  size="small"
                  sx={{
                    height: 16,
                    fontSize: "0.5rem",
                    fontWeight: 600,
                    bgcolor: alpha(color, 0.08),
                    color: color,
                  }}
                />
              )}
            </Box>
          )}
        </Box>
        <Avatar
          sx={{
            bgcolor: alpha(color, 0.08),
            color: color,
            width: 48,
            height: 48,
            borderRadius: "12px",
          }}
        >
          {icon}
        </Avatar>
      </Box>
    </Paper>
  );
};

export default QuickStatCard;